import { faBell } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useFeedbackValue } from "../Contexts/FeedbackContext";
import { useWebpushValue } from "../Contexts/WebpushContext";
import * as HostStatus from "../Types/HostStateTypes";
import sendTimedMessage from "../Helper/timeMessageHelper";
import { useHostValue } from "../Contexts/HostContext";
import * as Actions from "../Types/ReducerTypes";
import { useState } from "react";
import { sendGtmEvent, GoogleEvent } from "../GoogleTagManager";
function WebpushButton(_a) {
  var host = _a.host,
    position = _a.position;
  var _b = useFeedbackValue(),
    feedbackDispatch = _b[1];
  var _c = useHostValue(),
    state = _c[0],
    hostDispatch = _c[1];
  var _d = useState(false),
    hovered = _d[0],
    setHovered = _d[1];
  var push = useWebpushValue();
  if (window.layoutSettings.content.display.webpush === false) {
    return null;
  }
  if (document.location.host === 'call.beianrufsex.com') {
    return null;
  }
  if (!push.isValid()) {
    return null;
  }
  if (position !== 'profile' && HostStatus.is0900Online(host)) {
    return null;
  }
  function activate(userId, name) {
    push.activate(parseInt(userId, 10)).then(function () {
      sendTimedMessage({
        type: 'success',
        text: "Benachrichtigung f\u00FCr ".concat(name, " aktiviert")
      }, feedbackDispatch);
      hostDispatch({
        type: Actions.ADD_REGISTERED_HOST,
        userId: userId
      });
      if (position === 'host') {
        sendGtmEvent(GoogleEvent.HOST_WEBPUSH, 'activate');
      } else if (position === 'modalbox') {
        sendGtmEvent(GoogleEvent.MODALBOX_WEBPUSH, 'activate');
      } else if (position === 'profile') {
        sendGtmEvent(GoogleEvent.PROFILE_WEBPUSH, 'activate');
      }
    }).catch(function () {
      sendTimedMessage({
        type: 'warning',
        text: "Du willst doch nicht benachrichtigt werden? Das finde ich schade!"
      }, feedbackDispatch);
    });
  }
  function deactivate(userId, name) {
    push.deactivate(parseInt(userId, 10)).then(function () {
      sendTimedMessage({
        type: 'success',
        text: "Benachrichtigung f\u00FCr ".concat(name, " abbestellt")
      }, feedbackDispatch);
      hostDispatch({
        type: Actions.REMOVE_REGISTERED_HOST,
        userId: userId
      });
      if (position === 'host') {
        sendGtmEvent(GoogleEvent.HOST_WEBPUSH, 'deactivate');
      } else if (position === 'modalbox') {
        sendGtmEvent(GoogleEvent.MODALBOX_WEBPUSH, 'deactivate');
      } else if (position === 'profile') {
        sendGtmEvent(GoogleEvent.PROFILE_WEBPUSH, 'deactivate');
      }
    }).catch(function (err) {
      return sendTimedMessage({
        type: 'warning',
        text: err.message
      }, feedbackDispatch);
    });
  }
  var onClick = function (evt) {
    activate(host.id, host.name);
    evt.stopPropagation();
  };
  var className = "webpushButton c-webpush-button";
  var text = 'Benachrichtigt werden';
  var toolTip = "Klicke um anonym benachrichtigt zu werden, wenn ".concat(host.name, " wieder f\u00FCr dich da ist");
  if (state.registered.indexOf(host.id) !== -1) {
    onClick = function (evt) {
      deactivate(host.id, host.name);
      evt.stopPropagation();
    };
    className = 'webpushButton c-webpush-button c-webpush-button--active';
    text = 'Du wirst benachrichtigt';
    toolTip = "Klicke um Benachrichtigungen von ".concat(host.name, " zu deaktivieren");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'tooltip c-webpush-tooltip ' + (hovered && position !== 'profile' ? 'visible' : 'invisible')
  }, toolTip), /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    onMouseEnter: function () {
      return setHovered(true);
    },
    onMouseLeave: function () {
      return setHovered(false);
    },
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faBell
  }), "\u00A0", text));
}
export default WebpushButton;